"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "talmassons": {
    "13cb641d": [{
      "hkey": "90996bd0",
      "slug": "talmassons",
      "name": "Talmassons",
      "primary": true,
      "skipSearch": false
    }],
    "flambro": [{
      "hkey": "90996bd0",
      "slug": "talmassons",
      "name": "Talmassons",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d99f2268": [{
      "hkey": "90996bd0",
      "slug": "talmassons",
      "name": "Talmassons",
      "primary": true,
      "skipSearch": false
    }],
    "flumignano": [{
      "hkey": "90996bd0",
      "slug": "talmassons",
      "name": "Talmassons",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2743aef9": [{
      "hkey": "90996bd0",
      "slug": "talmassons",
      "name": "Talmassons",
      "primary": true,
      "skipSearch": false
    }],
    "sant-andrat": [{
      "hkey": "90996bd0",
      "slug": "talmassons",
      "name": "Talmassons",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;